
define('jst!address_book_export/_list',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% _.each(providers, function(provider) { %>\n  <div class="image-block">\n    <div class="img">\n      <div class="icon-32 icon-32-<%=provider.icon%>-small"></div>\n    </div>\n    <div class="img-ext">\n      <div class="button-new secondary baby-button <%=buttonClass%>" data-id="<%=provider[idProperty]%>"><%=buttonName%></div>\n    </div>\n    <div class="bd">\n      <%=provider.label%>\n    </div>\n  </div>\n<% }); %>');
 });

